module.exports = __webpack_public_path__ + "static/background-96803e549207d9dfdab2476baa700b3b.png";